export const ALARM_COLOR_KEYS = [
  "notDefined",
  "noData",
  "normal",
  "attention",
  "warning",
  "alarm",
  "invalid",
  "pickupFailed",
] as const;

export type AlarmColorCategory = (typeof ALARM_COLOR_KEYS)[number];

export type IUserAlarmColors = Record<AlarmColorCategory, string>;

export const DEFAULT_USER_ALARM_COLORS: IUserAlarmColors = {
  notDefined: "#ffffff",
  noData: "#c0c0c0",
  normal: "#66bb6a",
  attention: "#ffeb3b",
  warning: "#ff9800",
  alarm: "#f44336",
  invalid: "#ff00ff",
  pickupFailed: "#0000ff",
};

export function mapAlarmStatusToCategory(status: number): AlarmColorCategory {
  if (status === 255) return "noData";
  if (status === 0 || status === 10) return "notDefined";
  if (status === 30) return "normal";
  if (status === 45) return "attention";
  if (status === 60) return "warning";
  if (status === 90) return "alarm";
  if (status === 40) return "invalid";
  if (status === 50) return "pickupFailed";
  return "notDefined";
}

export function getDefaultAlarmColor(status: number): string {
  const key = mapAlarmStatusToCategory(status);
  return DEFAULT_USER_ALARM_COLORS[key];
}

export function mergeAlarmColors(partial?: Partial<IUserAlarmColors>): IUserAlarmColors {
  return { ...DEFAULT_USER_ALARM_COLORS, ...partial };
}

export function resolveAlarmColorFromPalette(status: number, palette: IUserAlarmColors): string {
  const key = mapAlarmStatusToCategory(status);
  return palette[key] ?? DEFAULT_USER_ALARM_COLORS[key];
}

export const isNeutralAlarmStatusCategory = (category: AlarmColorCategory): boolean =>
  category === "noData" || category === "notDefined";
